import {
  getQuoteInformation,
  createForm,
  sendNip,
  validateNip,
  validateCurp,
  validateContactInformation,
  submitForm,
  getAvalAddress
} from 'src/services/avalBuroFormService';
import { SnackBarVariants } from 'src/utils/constants/common';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import { setLocalStorage, removeLocalStorage } from 'src/utils/localStorage';
import { showMessage } from './snackBarActions';

export const LOAD_AVAL_QUOTE_INFO = asyncActionCreator('LOAD_AVAL_QUOTE_INFO');
export const CREATE_AVAL_BURO_FORM = asyncActionCreator('CREATE_AVAL_BURO_FORM');
export const RESEND_AVAL_NIP = asyncActionCreator('RESEND_AVAL_NIP');
export const VALIDATE_AVAL_NIP = asyncActionCreator('VALIDATE_AVAL_NIP');
export const VALIDATE_AVAL_CURP = asyncActionCreator('VALIDATE_AVAL_CURP');
export const VALIDATE_AVAL_CONTACT_INFO = asyncActionCreator(
  'VALIDATE_AVAL_CONTACT_INFO'
);
export const SUBMIT_AVAL_BURO_FORM = asyncActionCreator('SUBMIT_AVAL_BURO_FORM');
export const LOAD_AVAL_ADDRESS = asyncActionCreator('LOAD_AVAL_ADDRESS');
export const CLEAR_AVAL_TOKEN = 'CLEAR_AVAL_TOKEN';

export const loadAvalQuoteInfo = avalToken => async dispatch => {
  try {
    dispatch({ type: LOAD_AVAL_QUOTE_INFO.start });
    removeLocalStorage('avalTemporalToken');
    setLocalStorage('avalTemporalToken', avalToken);
    const response = await getQuoteInformation();
    dispatch({ type: LOAD_AVAL_QUOTE_INFO.success, payload: response });
  } catch (error) {
    removeLocalStorage('avalTemporalToken');
    const status =
      error.message && error.message.includes('403') ? '403' : '401';
    dispatch({ type: LOAD_AVAL_QUOTE_INFO.failure, payload: status });
  }
};

export const clearAvalToken = () => dispatch => {
  removeLocalStorage('avalTemporalToken');
  dispatch({ type: CLEAR_AVAL_TOKEN });
};

export const createAvalBuroFormAction = (values, onNext) => async dispatch => {
  try {
    dispatch({ type: CREATE_AVAL_BURO_FORM.start });
    const response = await createForm(values);
    const formId = response.formId ?? response;
    dispatch({ type: CREATE_AVAL_BURO_FORM.success, payload: formId });
    if (typeof onNext === 'function') onNext();
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    dispatch({ type: CREATE_AVAL_BURO_FORM.failure });
  }
};

export const resendAvalNipCode = () => async (dispatch, getState) => {
  try {
    dispatch({ type: RESEND_AVAL_NIP.start });
    const { formId } = getState().avalBuroForm;
    await sendNip(formId);
    dispatch({ type: RESEND_AVAL_NIP.success });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    dispatch({ type: RESEND_AVAL_NIP.failure });
  }
};

export const validateAvalNip = (nip, onNext) => async (dispatch, getState) => {
  try {
    dispatch({ type: VALIDATE_AVAL_NIP.start });
    const { formId } = getState().avalBuroForm;
    const validated = await validateNip({ formId, nip });
    if (!validated) {
      dispatch(
        showMessage({
          message: 'AVAL_BURO_FORM.INVALID_NIP',
          variant: SnackBarVariants.ERROR
        })
      );
      return dispatch({ type: VALIDATE_AVAL_NIP.failure });
    }
    dispatch({ type: VALIDATE_AVAL_NIP.success });
    return onNext();
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    return dispatch({ type: VALIDATE_AVAL_NIP.failure });
  }
};

export const validateAvalCurp = (values, onNext) => async dispatch => {
  const sex = values.curp ? values.curp[10] : values.sex;
  const baseValues = { ...values, ...(sex ? { sex } : {}) };

  if (process.env.REACT_APP_NUFI_ENABLED !== 'true') {
    return onNext(baseValues);
  }

  try {
    dispatch({ type: VALIDATE_AVAL_CURP.start });
    const response = await validateCurp(values.curp);
    dispatch({ type: VALIDATE_AVAL_CURP.success });
    return onNext({ ...baseValues, ...(response || {}) });
  } catch (_error) {
    dispatch({ type: VALIDATE_AVAL_CURP.failure });
    return onNext(baseValues);
  }
};

export const validateAvalContactInfo = (values, onNext) => async dispatch => {
  try {
    dispatch({ type: VALIDATE_AVAL_CONTACT_INFO.start });
    await validateContactInformation({
      phone: values.phone,
      email: values.email
    });
    dispatch({ type: VALIDATE_AVAL_CONTACT_INFO.success });
    return onNext(values);
  } catch (_error) {
    dispatch({ type: VALIDATE_AVAL_CONTACT_INFO.failure });
    return onNext(values);
  }
};

export const loadAvalAddressByZipCode = (zipCode, setState) => async dispatch => {
  try {
    dispatch({ type: LOAD_AVAL_ADDRESS.start });
    const data = await getAvalAddress(zipCode);
    setState({ ...data, isValid: true });
    dispatch({ type: LOAD_AVAL_ADDRESS.success });
  } catch (_error) {
    setState({ cities: [], colonias: [], municipalities: [], states: [], isValid: false });
    dispatch({ type: LOAD_AVAL_ADDRESS.failure });
  }
};

export const submitAvalBuroForm = (values, onNext) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: SUBMIT_AVAL_BURO_FORM.start });
    const { formId } = getState().avalBuroForm;
    const result = await submitForm({ formId, data: values });
    dispatch({ type: SUBMIT_AVAL_BURO_FORM.success, payload: result });
    onNext();
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    dispatch({ type: SUBMIT_AVAL_BURO_FORM.failure });
  }
};
